import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageViewFull } from '../utils/analytics';

/**
 * Analytics component that tracks page views automatically
 * Add this to your App.js to enable automatic page view tracking
 */
const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA on mount
    initGA();
  }, []);

  useEffect(() => {
    // Track page view on route change
    trackPageViewFull(location.pathname + location.search);
  }, [location]);

  return null; // This component doesn't render anything
};

export default Analytics;
